import React, {useEffect, useState} from "react";
import IPartner from "../../interfaces/IPartner";
import "./Partners.scss";
import IMapConfig from "../../interfaces/IMapConfig";

const Partners: React.FC<{ mapConfig: IMapConfig, setMapConfig: Function, partners: IPartner[] }> = props => {
    const [nbAgencies, setNbAgencies] = useState<number>(0);
    const [strList, setStrList] = useState<string>('');

    const showHideMsg = props.mapConfig.showPartnersLoc ? 'Cacher les agences membres Interkab' : 'Montrer les agences membres Interkab';

    useEffect(() => {
        const length = props.partners.length;

        let count = 0;
        let countAgencies = 0;
        let strList = '';

        props.partners.forEach(({name, postalCode, nbAgencies}) => {
            ++count;

            const last = count === length;

            if (nbAgencies) {
                countAgencies += nbAgencies;
            }

            if (name && postalCode) {
                strList += `${name} (${postalCode})`;

                if (1 < length && !last) {
                    strList += ', ';
                }
            }
        });

        setNbAgencies(countAgencies);
        setStrList(strList);
    }, [props.partners]);

    const onShowHideClickHandler = () => {
        const mapConfigUpd = {...props.mapConfig};

        mapConfigUpd.showPartnersLoc = !mapConfigUpd.showPartnersLoc;

        props.setMapConfig({...mapConfigUpd});
    };

    return (
        <div className="bodyPartners">
            <div className="switchPartnersIka">
                <span className="switchTitle">{showHideMsg}</span>
                <button
                    className={`switchBtn ${props.mapConfig.showPartnersLoc ? 'active' : ''}`}
                    onClick={onShowHideClickHandler}/>
            </div>

            <div className="partners">
                <div className="agenciesNb">
                    <div className="count">
                        {nbAgencies}
                    </div>
                </div>
                <div className="text">
                    agence partenaires interkab
                </div>
            </div>

            {strList.length > 0 &&
                <div className="sectors">
                    <div className="label">
                        secteurs :
                    </div>
                    <div className="list">
                        {strList}
                    </div>
                </div>
            }
        </div>
    );
};

export default Partners;
